<template>
		<el-dialog title="修改字典" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
						<el-form-item label="类型">
								<el-input v-model="form.dictType" placeholder="请输入"></el-input>
						</el-form-item>
						
						<br>
						<el-form-item label="选项名称">
								<el-input v-model="form.dictName" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {BaseDictionaryUpdate} from "@/api/setting";
import {getToken} from "@/utils/auth";
import {mapGetters} from "vuex";

export default {
		name: "EditDataObjectDialog",
		components: {},
		computed: {
				...mapGetters([ 'BaseDictionaryList_typeDDL'])
		},
		props: ['visible', 'currentItem'],
		watch: {
				async visible(newValue) {
						// await this.$store.dispatch('source/getMediumList',);
						if (newValue) {
								// const {typeID,mediumIds} = this.currentItem;
								// if (typeID) {
								// 		this.currentItem.mediumIds = mediumIds?.split(',').filter(item => item !== '').map(item => parseInt(item)) ?? [];
										this.form = this.currentItem;
								// }
						}
				}
		},
		data() {
				return {
						form: { dictType: '', dictName: ''}
				};
		},
		methods: {
				async onConfirm() {
						console.log(this.form);
						const { dictType, dictName, dictID:dictId} = this.form;
						if (!dictName.trim()) {
								this.$message.warning('请将选项内容补充完整');
								return;
						}
						await BaseDictionaryUpdate({userId: getToken(), dictId, dictType, dictName});
						this.$message.success('修改成功');
						this.form = { dictType: '', dictName: ''};
						this.beforeClose();
						await this.$store.dispatch('setting/BaseDictionaryList',);
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>